<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Prosedür {{data ? 'Güncelle' : 'Ekle'}}</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" tabindex="0" ngbAutofocus>
    <form [formGroup]="form">
        <div class="col-xl-12 col-md-12 col-12 mb-1" [ngClass]="{'disabled-input': isDisabled()}">
            <div class="form-group">
                <label for="name">Başlık</label>
                <input type="text" class="form-control" id="name" formControlName="name" placeholder="Başlık"
                    maxlength="250" />
            </div>
        </div>

        <div class="d-flex" [ngClass]="{'disabled-input': isDisabled()}">
            <div class="form-group col-6">
                <label for="kindId">Türler</label>
                <ng-select [items]="kinds" bindLabel="typeName" bindValue="id" formControlName="kindId"></ng-select>
            </div>

            <div class="form-group col-6">
                <label for="status">Durum</label>
                <select class="form-control mx-25" formControlName="status">
                    <option value="true">Aktif</option>
                    <option value="false">Pasif</option>
                </select>
            </div>
        </div>

        <div class="form-group col-xl-12 col-md-12 col-sm-12 col-12">
            <quill-editor formControlName="description">
                <div quill-editor-toolbar>
                    <span class="ql-formats">
                        <select class="ql-size" [title]="'Font Size'">
                            <option value="small"></option>
                            <option selected></option> <!-- Normal (Varsayılan) -->
                        </select>
                    </span>
                </div>
            </quill-editor>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()" rippleEffect>
        İptal
    </button>
    <button type="button" class="btn btn-success" rippleEffect (click)="onSubmit()" [disabled]="form.invalid">
        {{data ? 'Güncelle' : 'Ekle'}}
    </button>
</div>